import React from 'react';
import { Dropdown, DropdownProps } from 'semantic-ui-react';
import styled from 'styled-components';

export type ClaimPendencyResponsible = 'Seguradora' | 'Corretora';
export type ClaimPendencyType = 'Danos' | 'Aluguel';

export type ClaimPendencyValues = {
  responsible?: ClaimPendencyResponsible;
  type?: ClaimPendencyType;
};

const responsibleOptions = [
  { key: 'broker', value: 'Corretora', text: 'Corretora' },
  { key: 'insurer', value: 'Seguradora', text: 'Seguradora' }
];

const typeOptions = [
  { key: 'rent', value: 'Aluguel', text: 'Aluguel' },
  { key: 'damages', value: 'Danos', text: 'Danos' }
];

const FieldsContainer = styled.div`
  display: flex;
  gap: 20px;
  flex: 1;
  margin-top: 10px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 10px;
    width: 100%;
  }
`;

const FieldWrapper = styled.div`
  width: 220px;

  label {
    display: block;
    color: #2f3441;
    font-size: 12px;
    font-weight: 700;
    margin-bottom: 4px;
  }

  .ui.selection.dropdown {
    min-height: 40px;
    border-color: #dddddd;
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const RequiredMark = styled.span`
  color: #ff3b30;
`;

type ClaimFollowUpPendencyFieldsProps = {
  values: ClaimPendencyValues;
  disabled?: boolean;
  onChange: (values: ClaimPendencyValues) => void;
};

const ClaimFollowUpPendencyFields = ({
  values,
  disabled,
  onChange
}: ClaimFollowUpPendencyFieldsProps) => {
  const handleResponsibleChange = (_event: React.SyntheticEvent, data: DropdownProps) => {
    onChange({
      ...values,
      responsible: data.value as ClaimPendencyResponsible
    });
  };

  const handleTypeChange = (_event: React.SyntheticEvent, data: DropdownProps) => {
    onChange({
      ...values,
      type: data.value as ClaimPendencyType
    });
  };

  return (
    <FieldsContainer>
      <FieldWrapper>
        <label>
          Responsável pela pendência <RequiredMark>*</RequiredMark>
        </label>
        <Dropdown
          fluid
          selection
          clearable
          disabled={disabled}
          options={responsibleOptions}
          placeholder="Selecione"
          value={values.responsible || ''}
          onChange={handleResponsibleChange}
        />
      </FieldWrapper>

      <FieldWrapper>
        <label>
          Tipo de pendência <RequiredMark>*</RequiredMark>
        </label>
        <Dropdown
          fluid
          selection
          clearable
          disabled={disabled}
          options={typeOptions}
          placeholder="Selecione"
          value={values.type || ''}
          onChange={handleTypeChange}
        />
      </FieldWrapper>
    </FieldsContainer>
  );
};

export default ClaimFollowUpPendencyFields;
